import { CommonModule } from '@angular/common';
import { LottieModule } from 'ngx-lottie';
import { NgModule } from '@angular/core';
import player from "lottie-web";

import { AccountEditComponent } from './settings-modal/account-edit/account-edit.component';
import { AccountRoutingModule } from './account-routing.module';
import { ConsentsComponent } from './shared/consents/consents.component';
import { DeleteAccountComponent } from './settings-modal/delete-account/delete-account.component';
import { HelpComponent } from './settings-modal/help/help.component';
import { LegalComponent } from './settings-modal/legal/legal.component';
import { ProfileComponent } from './shared/profile/profile.component';
import { SettingsModalComponent } from './settings-modal/settings-modal.component';
import { SharedModule } from '../shared/shared.module';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    SettingsModalComponent,
    DeleteAccountComponent,
    HelpComponent,
    LegalComponent,
    AccountEditComponent,
    ConsentsComponent,
    ProfileComponent,
  ],
  imports: [CommonModule, AccountRoutingModule, SharedModule, LottieModule.forRoot({ player: playerFactory })],
  exports: [],
})
export class AccountModule {}
